<template>
    <div>
        <div v-if="payedTill" class="flex flex-column align-items-end">
            <span class="label_text">{{ getLabel }}</span>
            <span class="font-bold">{{ formatDate(payedTill) }}</span>
        </div>
        <span v-else class="label_text inline-block mt-2">
            {{ $t('lang.main.subs_form_not_payed') }}
        </span>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "PayedTill",
    props: {
        payedTill: {
            type: Date,
        },
        expired: {
            type: Boolean,
            default: () => false,
        }
    },
    computed: {
        getLabel() {
            return this.expired ? this.$t('lang.main.subs_form_expired') : this.$t('lang.main.subs_form_payed_date');
        }
    },
    methods: {
        formatDate: date => moment(date).format('DD.MM.YYYY HH:mm')
    }
}
</script>

<style scoped>
span {
    font-size: 0.875rem;
    line-height: 1rem;
}
.label_text {
    color: var(--text-color-secondary);
}
</style>
